import type { CommonAddress } from '@models/interfaces/commonAddress';
import { computed, ref, type Ref } from 'vue';
import { getDistrict } from '@tools/address-utils.ts';

type Address = Pick<CommonAddress, 'street' | 'zip_code' | 'city'>;

export const useStreetDistrict = (addressValue: Address | Ref<Address>) => {
  const address: Ref<Address> = ref(addressValue);

  const capitalizeFirstLetter = (str: string): string => str.charAt(0).toUpperCase() + str.substring(1);

  const formattedAddress = computed<string>(() => {
    if (!address.value.street) {
      return `${address.value.city}, ${address.value.zip_code}`;
    }

    return `${address.value.street.trim()}, ${address.value.city}`;
  });

  const cityDistrict = computed<number | null>(() => getDistrict(address.value.zip_code));

  const formattedStreetDistrict = computed<string>(() => {
    const capitalizedStreetDistrict = capitalizeFirstLetter(formattedAddress.value);

    return cityDistrict.value ? `${capitalizedStreetDistrict} ${cityDistrict.value}` : capitalizedStreetDistrict;
  });

  return {
    formattedAddress,
    cityDistrict,
    formattedStreetDistrict,
  };
};
